import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Dashboard from './components/Dashboard';
import FloorPlan from './components/FloorPlan';
import PublicHeader from './components/PublicHeader';
import AdminPanel from './components/admin/AdminPanel';
import ApplicationHistory from './components/ApplicationHistory';
import Navigation from './components/Navigation';
import axios from 'axios';

// Axios base URL ayarla: production'da API alt alan adını kullan
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.korkmazlarkoy.com' : 'http://localhost:5000';

// Protected Route Component
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Yükleniyor...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

// Header seçici: kullanıcı yoksa PublicHeader, varsa Navigation
const HeaderChooser = () => {
  const { user } = useAuth();
  return user ? <Navigation /> : <PublicHeader />;
};

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="App">
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
          
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Public home: redirect to 1st floor */}
            <Route path="/" element={<Navigate to="/floor/1" replace />} />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <div>
                  <Navigation />
                  <Dashboard />
                </div>
              </ProtectedRoute>
            } />
            
            {/* Public floor plan: oturum yoksa PublicHeader, varsa Navigation */}
            <Route path="/floor/:floorNumber" element={
              <div>
                <HeaderChooser />
                <FloorPlan />
              </div>
            } />
            
            <Route path="/applications" element={
              <ProtectedRoute>
                <div>
                  <Navigation />
                  <ApplicationHistory />
                </div>
              </ProtectedRoute>
            } />
            
            <Route path="/admin" element={
              <ProtectedRoute requireAdmin={true}>
                <div>
                  <Navigation />
                  <AdminPanel />
                </div>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 